import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api, { setToken } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const afterLogin = () => {
  const to = sessionStorage.getItem("mulankan_after_login");
  sessionStorage.removeItem("mulankan_after_login");
  return to && to.startsWith("/") && !to.startsWith("//") ? to : "/flow";
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const applyAuth = useCallback((payload) => {
    if (payload?.token) setToken(payload.token);
    setUser(payload.user);
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch {}
    setToken(null);
    setUser(false);
  }, []);

  const refreshUser = useCallback(async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); } catch {}
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, loading, applyAuth, logout, refreshUser, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}
